import { VdActiveUser, VdTracking } from '@vend/vend.js'

import { StateProvider } from '@uirouter/angularjs'
import { getRetailer } from '@vend/utilities'
import { getCoreTrackingConfig } from '../tracking/getCoreTrackingConfig'

import { STATES } from '../../../../lib/routes'
import { $q, $state, $transitions, $window } from '../../ng-compat/imports'
import { WebRegisterStatusManager } from '../../managers/web-register-status-manager'
import registersUnavailableTemplate from './registers-unavailable.html'

export function RestrictedAccessRoutesConfig($stateProvider: StateProvider) {
  'ngInject'

  $stateProvider
    .state(STATES.RESTRICTED_ACCESS, {
      abstract: true,
      resolve: {
        // Setting `restrictedAccess` for all child states. `webRegisterStatusManager` will emit a corresponding event.
        updateRestrictedAccess(
          vdActiveUser: VdActiveUser,
          vdTracking: VdTracking,
          webRegisterStatusManager: WebRegisterStatusManager
        ) {
          'ngInject'

          webRegisterStatusManager.restrictedAccess = true

          // Register is in a restricted state so prevent any state change.
          $transitions.onStart({}, () => {
            return false
          })

          // Initialize vdTracking. In some restricted states not all required entities needed for vdTracking (or even
          // vdTracking itself) are initialized.
          $q.all([vdActiveUser.init(), getRetailer()]).then(([, retailer]) => {
            const trackingConfig = {
              ...getCoreTrackingConfig(),
              retailerDomainPrefix: $window.location.hostname,
              retailerId: retailer.id,
              retailerAccountStatus: retailer.account_status,
              userId: (vdActiveUser as $TSFixMe).getLoggedInUser().id,
            }

            vdTracking.init(trackingConfig).then(() => {
              vdTracking.trackUserEvent({
                eventName: 'Restricted State',
                metadata: {
                  state: $state.current.name,
                },
              })

              // Don't resolve the transition
              return false
            })
          })
        },
      },
    })
    .state(STATES.REGISTERS_UNAVAILABLE, {
      views: {
        '@webregister': {
          template: registersUnavailableTemplate,
        },
      },
    })
    .state(STATES.DUPLICATE_WINDOW, {
      views: {
        '@webregister': {
          template: '<react-duplicate-window></react-duplicate-window>',
        },
      },
    })
}
